<template>
  <div style="background:#fff;">
    <header-info cur="-1"></header-info>
    <div class="center">
      <div class="testing-wrap">
        <span
          class="back"
          @click="backToDetail"
        >返回</span>
        <div class="test-title">测试1</div>
        <!--        <p class="time" >提交截止时间：<b style="color:red">(已过)</b></p>-->
        <!--        <p class="score">最高得分：</p>-->
        <h3 v-if="singleCount > 0">单选题（共{{ singleCount }}题）</h3>
        <div
          v-for="(item, index) in singleQuestion"
          :key="'S' + index"
        >
          <div class="topic">
            <div class="subject">{{ index + 1 }}、（{{ parseInt(item.grade) }}分）<p v-html="item.content"></p>
            </div>
            <p
              class="option"
              v-for="(option, i) in item.options"
              :key="'s_' + i"
            >
              <label>
                <input
                  type="radio"
                  @change="onRadioChange(item.options),option.isSelect=1"
                  :name="'s_'+ index"
                >
                <span>{{ optionArry[i] }}、{{ option.title }}</span>
              </label>
            </p>
          </div>
        </div>
        <h3 v-if="multipleCount > 0">多选题（共{{ multipleCount }}题）</h3>
        <div
          v-for="(item, index) in multipleQuestion"
          :key="'M' + index"
        >
          <div class="topic">
            <div class="subject">{{ index + 1 }}、（{{ parseInt(item.grade) }}分）<p v-html="item.content"></p>
            </div>
            <p
              class="option"
              v-for="(option, i) in item.options"
              :key="'m_' + i"
            >
              <label>
                <input
                  type="checkbox"
                  @change="option.isSelect = (option.isSelect ? 0 : 1)"
                  :name="'m_'+ index"
                >
                <span>{{ optionArry[i] }}、{{ option.title }}</span>
              </label>
            </p>
          </div>
        </div>
        <h3 v-if="judgeCount > 0">判断题（共{{ judgeCount }}题）</h3>
        <div
          v-for="(item, index) in judgeQuestion"
          :key="'J' + index"
        >
          <div class="topic">
            <div class="subject">{{ index + 1 }}、（{{ parseInt(item.grade) }}分）<p v-html="item.content"></p>
            </div>
            <p
              class="option"
              v-for="(option, i) in item.options"
              :key="'j_' + i"
            >
              <label>
                <input
                  type="radio"
                  @change="onRadioChange(item.options),option.isSelect=1"
                  :name="'j_'+ index"
                >
                <span>{{ optionArry[i] }}、{{ option.title }}</span>
              </label>
            </p>
          </div>
        </div>
        <p class="btn_wrap">
          <span
            class="btn_sub"
            id="test-submit"
            @click="submitTest"
          >提交答案</span>
        </p>
      </div>
    </div>
    <div
      id="south"
      ref="south"
    >
      <footer-info></footer-info>

    </div>

  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'

export default {
  name: 'MyLessonTest',
  components: {
    HeaderInfo,
    FooterInfo
  },
  data() {
    return {
      optionArry: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'],
      // 是否过期
      isExpired: false,
      questionList: [],
      optionList: []
    }
  },
  computed: {
    singleCount () {
      return this.questionList.filter(m => m.questionType === 1).length
    },
    multipleCount () {
      return this.questionList.filter(m => m.questionType === 2).length
    },
    judgeCount () {
      return this.questionList.filter(m => m.questionType === 3).length
    },
    singleQuestion () {
      return this.questionList.filter(m => m.questionType === 1)
    },
    multipleQuestion () {
      return this.questionList.filter(m => m.questionType === 2)
    },
    judgeQuestion () {
      return this.questionList.filter(m => m.questionType === 3)
    }
  },
  methods: {
    // 获取题目
    async getTestQuestion() {
      await this.$http.get('/online_question/', {
        params: { // 题目
          page: 1,
          size: 500,
          exam_id: this.$route.query.TestId
        }
      }).then((data) => {
        if (data.count) {
          this.questionList = data.results
          this.getTestQuestionOption()
        }
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    // 获取选项
    async getTestQuestionOption() {
      await this.$http.get('/online_question_option/', {
        params: {
          exam_id: this.$route.query.TestId,
          page: 1,
          size: 10000
        }
      }).then((data) => {
        if (data.count) {
          this.optionList = data.results
          for (let i = 0; i < this.optionList.length; i++) {
            this.$set(this.optionList[i], 'isSelect', 0)
          }
          for (let i = 0; i < this.questionList.length; i++) {
            const options = []
            for (let j = 0; j < this.optionList.length; j++) {
              if (this.questionList[i].id === this.optionList[j].question_id) {
                options.push(this.optionList[j])
              }
            }
            this.$set(this.questionList[i], 'options', options)
          }
        }
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    // 单选框选中时 先去掉之前的选中项
    onRadioChange(options) {
      for (let i = 0; i < options.length; i++) {
        options[i].isSelect = 0
      }
    },
    // 提交答案
    async submitTest () {
      const data = {
        onlineExam_id: this.$route.query.TestId,
        onlineStudent_id: this.$route.query.studentId,
        questions: []
      }
      for (let i = 0; i < this.questionList.length; i++) {
        let option = ''
        for (let j = 0; j < this.questionList[i].options.length; j++) {
          if (this.questionList[i].options[j].isSelect === 1) {
            option === '' ? option += this.questionList[i].options[j].code : option += ',' + this.questionList[i].options[j].code
          }
        }
        data.questions.push({
          question_id: this.questionList[i].id,
          option: option
        })
      }

      const checkExamData = await this.$http.get('/online_student_exam/', {
        params: {
          onlineExam_id: this.$route.query.TestId,
          onlineStudent_id: this.$route.query.studentId
        }
      })

      if (checkExamData.results.length > 0) {
        this.$layer.msg('您已经提交过考试，不能再次提交！')
        return false
      }

      await this.$http.post('/online_student_exam_save/', {
        json_data: JSON.stringify(data)
      }).then((data) => {
        this.$layer.msg('提交成功！')
        setTimeout(() => {
          this.backToDetail()
        }, 1000)
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('操作失败！')
      })
    },
    backToDetail () {
      this.$router.push('/my/lesson/detail?id=' + this.$route.query.id + '&studentId=' + this.$route.query.studentId)
    }
  },
  mounted() {
    this.getTestQuestion()
  }
}
</script>

<style lang="less" scoped>
.center {
  width: 1200px;
  margin: 20px auto 0;
  padding-bottom: 110px;
}
.testing-wrap {
  padding: 20px;
  border: 1px solid #e3eceb;
  position: relative;
  .back {
    padding: 5px 20px;
    background: #4caf50;
    color: #fff;
    border-radius: 3px;
    box-shadow: 2px 2px 5px #ccc;
    position: absolute;
    right: 20px;
    cursor: pointer;
  }
  .test-title {
    font-size: 20px;
    text-align: center;
    color: #666;
    span {
      font-size: 13px;
      padding-left: 10px;
      font-weight: lighter;
      color: #666666;
    }
  }
  .time {
    text-align: center;
    padding-top: 10px;
    color: #666;
  }
  .score {
    color: #ff0000;
    padding: 10px 0;
    text-align: center;
  }
  .exp-wrap {
    .exp-item {
      overflow: hidden;
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px dotted #d3d3d3;
      .exp-item-left {
        float: left;
        width: 260px;
        height: 150px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .exp-item-right {
        float: left;
        margin-left: 30px;
        .school {
          font-size: 16px;
          margin-top: 8px;
          font-size: 14px;
        }
        .goExp {
          a {
            color: #337ab7;
            &:hover {
              text-decoration: underline;
            }
          }
          span {
            cursor: pointer;
            display: inline-block;
            margin-top: 10px;
            width: 75px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #73D6CA;
            color: #fff;
            border-radius: 4px;
          }
        }
        .exp-title {
          font-size: 16px;
          display: inline-block;
          color: #337ab7;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  h3 {
    font-weight: 400;
    font-size: 16px;
    color: #333;
    padding-bottom: 10px;
    padding-top: 20px;
  }
  .topic {
    border-bottom: 1px dotted #d3d3d3;
    padding-bottom: 20px;
    margin-bottom: 20px;
    .subject {
      line-height: 24px;
      font-size: 14px;
      color: #333;
      padding: 5px 10px;
      margin-bottom: 10px;
      p {
        margin: 0 0 10px;
      }
    }
    .option {
      font-size: 14px;
      position: relative;
      color: #666;
      padding-left: 10px;
      font-weight: 600;
      border: 1px solid #fff;
      margin-bottom: 10px;
      .TColor {
        color: #009999;
      }
      .FColor {
        color: #cc0000;
      }
      input {
        height: 14px;
        width: 14px;
        position: relative;
        top: 2px;
        margin-right: 10px;
      }
      label {
        display: block;
        width: 95%;
        padding: 6px 0 6px 0;
      }
      &:hover {
        background: #f3f3f3;
        border: 1px dashed #7bc5a6;
      }
    }
    .score-detail {
      width: 100%;
      margin-top: 10px;
      line-height: 32px;
      .label {
        color: #555;
        display: block;
        float: left;
        line-height: 32px;
        width: 40px;
        margin-left: 13px;
      }
      input {
        background: #fbfbfb;
        border: 1px solid #dddddd;
        height: 32px;
        line-height: 32px;
        width: 100px;
        padding: 0 5px;
      }
      .imgMsg {
        padding-left: 55px;
        color: #009999;
      }
    }
  }
  .btn_wrap {
    text-align: center;
    .btn_sub {
      background: #1a61ab;
      color: #fff;
      height: 36px;
      line-height: 34px;
      text-align: center;
      padding: 0 30px;
      cursor: pointer;
      display: inline-block;
      margin: 20px auto;
      font-size: 15px;
      border-radius: 5px;
    }
  }
}
</style>
